import { useQuery, useMutation } from "@tanstack/react-query";
import { api } from "../../config";

 function useGetOrders(params, enabl) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/orders`, {params});
            return res.data;
        },
        queryKey: ['paged-orders', params?.export],
        enabled: enabl,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useGetOrdersMetrics(enabl, filters) {
    return useQuery({
        queryFn: async () => {
            const res = await api.get(`/orders/metrics`, {params: filters});
            return res.data;
        },
        queryKey: ['metrics-orders'],
        enabled: enabl,
        retry: false,
        refetchOnWindowFocus: false
    })
}

function useUpdateOrdersManually() {
    return useMutation({
        mutationFn: async (data) => {
            const res = await api.post(`/orders/update/manually`, data);
            return res.data;
        },
        mutationKey: ['update-orders-manually'],
        retry: false
    })
}

function useGetOrdersForExport() {
    return useMutation({
        mutationFn: async (filters) => {
            const res = await api.get(`/orders`, {
                params: {
                    ...filters,
                    export: true
                }
            });
            return res.data;
        },
        mutationKey: ['export-orders'],
        retry: false
    })
}


export {
    useGetOrders,
    useGetOrdersMetrics,
    useUpdateOrdersManually,
    useGetOrdersForExport
}